import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const commandStyle: React.CSSProperties = {
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: 4,
    overflowX: 'auto',
    padding: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
};

export default function Instructions() {
    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} >
                        <h3 style={{ textAlign: "left" }}>File Access</h3>
                        <br />
                        <Item style={{ textAlign: "left", padding: 20 }}>
                            <p style={{ marginTop: 0 }}>This guide is provided to help you download files from our S3-compatible storage system.</p>
                            <p>You can use any download client that supports S3-compatible storage, or you can download files with the AWS CLI.</p>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                ><Typography><strong>Use an S3-compatible download client</strong></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography component="div">
                                        <p>Choose a client that supports S3-compatible storage and configure it with these connection details:</p>
                                        <ul>
                                            <li>Protocol: S3 or Amazon S3</li>
                                            <li>Endpoint, server, or host: s3-ext.decode.is</li>
                                            <li>Port: 443</li>
                                            <li>Connection type: HTTPS</li>
                                            <li>Access Key ID: use the access key provided to you</li>
                                            <li>Secret Access Key: use the secret key provided to you</li>
                                            <li>Bucket, path, or remote directory: use the bucket name provided to you</li>
                                        </ul>
                                        <p>After connecting, download the files or folders that were shared with you.</p>
                                    </Typography> 
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                ><Typography><strong>Use the AWS CLI</strong></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography component="div">
                                        <p>Install the AWS CLI, then configure a named profile with the credentials provided to you:</p>
                                        <pre style={commandStyle}>
{`aws configure --profile decode-download`}
                                        </pre>
                                        <p>Use <code>us-east-1</code> as the region if the CLI asks for one. The output format can be left blank or set to <code>json</code>.</p>
                                        <p>List the files in your bucket:</p>
                                        <pre style={commandStyle}>
{`aws --profile decode-download --endpoint-url https://s3-ext.decode.is s3 ls s3://<bucket-name>/`}
                                        </pre>
                                        <p>Download a single file:</p>
                                        <pre style={commandStyle}>
{`aws --profile decode-download --endpoint-url https://s3-ext.decode.is s3 cp s3://<bucket-name>/<path>/<file-name> ./`}
                                        </pre>
                                        <p>Download a folder or bucket prefix:</p>
                                        <pre style={commandStyle}>
{`aws --profile decode-download --endpoint-url https://s3-ext.decode.is s3 sync s3://<bucket-name>/<path>/ ./download/`}
                                        </pre>
                                        <ul>
                                            <li>Replace <code>&lt;bucket-name&gt;</code> with the bucket name provided to you.</li>
                                            <li>Replace <code>&lt;path&gt;</code> and <code>&lt;file-name&gt;</code> with the folder and file names you want to download.</li>
                                            <li>Omit <code>&lt;path&gt;/</code> to download from the top level of the bucket.</li>
                                        </ul>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <br />
                            <InfoIcon fontSize={"medium"} style={{ verticalAlign: "bottom", color: "#ac0533", marginRight: 5 }} />
                            <p style={{ display: "inline" }}>If you encounter any issues or have questions concerning the download process you can contact us at webservice@decode.com. Any issue with the data should be directed to the corresponding authors.</p>
                        </Item>
                    </Grid>

                </Grid>
            </Box>
            <Paper sx={{
                marginTop: 'calc(10% + 60px)',
                width: '70% !important',
                position: 'fixed',
                bottom: 0,
            }} component="footer" square>
                <Container maxWidth="lg">

                    <Typography variant="caption" color="initial">
                        Copyright © 2023 deCODE genetics
                    </Typography>

                </Container>
            </Paper>
        </>
    );
}
